module.exports = {"id":"dp1_2l1q5","text":"Evaluating Information","instructions":"Can social media platforms influence what information you see?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":false,"options":[{"id":"dp1_2l1q5-a1","text":"Yes","score":1.8},{"id":"dp1_2l1q5-a2","text":"Not sure","score":0},{"id":"dp1_2l1q5-a3","text":"No","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l1q5.json
// module id = 947
// module chunks = 41